export const title = 'Active users (Chart)';

Number of unique users who opened the app at least once over time.
